export const ADDITIONAL_FUNCTIONALITY = 'ADDITIONAL_FUNCTIONALITY';
export const BREAKING_CHANGE = 'BREAKING_CHANGE';
export const INITIAL_RELEASE = 'INITIAL_RELEASE';
export const PERMISSIONS_CHANGE = 'PERMISSIONS_CHANGE';
export const PRICING_CHANGE = 'PRICING_CHANGE';
export const REDESIGN = 'REDESIGN';
export const SUNSET = 'SUNSET';
export const RolloutTypes = {
  ADDITIONAL_FUNCTIONALITY,
  BREAKING_CHANGE,
  INITIAL_RELEASE,
  PERMISSIONS_CHANGE,
  PRICING_CHANGE,
  REDESIGN,
  SUNSET
};
export const ALPHA = 'ALPHA';
export const IN_DEVELOPMENT = 'IN_DEVELOPMENT';
export const LIVE = 'LIVE';
export const PHASED_ROLLOUT = 'PHASED_ROLLOUT';
export const PRIVATE_BETA = 'PRIVATE_BETA';
export const PUBLIC_BETA = 'PUBLIC_BETA';
export const UPCOMING_SUNSET = 'UPCOMING_SUNSET';
export const ORDERED_ROLLOUT_STATES = [IN_DEVELOPMENT, PRIVATE_BETA, PUBLIC_BETA, UPCOMING_SUNSET, SUNSET, LIVE];
export const RolloutStates = {
  ALPHA,
  IN_DEVELOPMENT,
  LIVE,
  PHASED_ROLLOUT,
  PRIVATE_BETA,
  PUBLIC_BETA,
  SUNSET,
  UPCOMING_SUNSET
};